import { render, staticRenderFns } from "./ServiceMessage.vue?vue&type=template&id=6704998d&"
import script from "./ServiceMessage.vue?vue&type=script&lang=js&"
export * from "./ServiceMessage.vue?vue&type=script&lang=js&"
import style0 from "./ServiceMessage.vue?vue&type=style&index=0&id=6704998d&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports